import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import WKTWriter from '../../io/WKTWriter';
var GeometryLocation = /*#__PURE__*/function () {
  function GeometryLocation() {
    _classCallCheck(this, GeometryLocation);
    GeometryLocation.constructor_.apply(this, arguments);
  }
  _createClass(GeometryLocation, [{
    key: "getSegmentIndex",
    value: function getSegmentIndex() {
      return this._segIndex;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      return this._pt;
    }
  }, {
    key: "isInsideArea",
    value: function isInsideArea() {
      return this._segIndex === GeometryLocation.INSIDE_AREA;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this._component.getGeometryType() + '[' + this._segIndex + ']' + '-' + WKTWriter.toPoint(this._pt);
    }
  }, {
    key: "getGeometryComponent",
    value: function getGeometryComponent() {
      return this._component;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._component = null;
      this._segIndex = null;
      this._pt = null;
      if (arguments.length === 2) {
        var component = arguments[0],
          pt = arguments[1];
        GeometryLocation.constructor_.call(this, component, GeometryLocation.INSIDE_AREA, pt);
      } else if (arguments.length === 3) {
        var _component = arguments[0],
          segIndex = arguments[1],
          _pt = arguments[2];
        this._component = _component;
        this._segIndex = segIndex;
        this._pt = _pt;
      }
    }
  }]);
  return GeometryLocation;
}();
export { GeometryLocation as default };
GeometryLocation.INSIDE_AREA = -1;